<template>
  <footer>
    <p>SITCON 學生計算機年會 / SITCON 夏令營</p>
  </footer>
</template>

<script>
export default {
  name: 'footers'
}
</script>


<style lang="stylus">
footer
  min-height: 30vw
  background-image: url('../assets/footer.svg')
  background-repeat: no-repeat
  background-position: center bottom
  background-size: cover
  padding-top: 5vh
  p
    text-align: center
    -webkit-margin-after: 0
</style>




// WEBPACK FOOTER //
// Footer.vue?00921fce